<!-- TODO: Keep this div, and remove the one above, once granular spend control goes live -->
<div
  class="granular-spend-control spend-control-tooltip phx-web-type-body-small mb-4 mt-4"
  #granularSpendControlTooltip
>
  <div class="phx-web-type-title-small white mb-8" i18n>
    {{spendProfile?.name}}
  </div>

  <section *ngIf="spendProfile?.enableStartTime">
    <div class="spend-control-tooltip-title" i18n>Time Limits</div>
    <p>{{timeLimitText}}</p>
  </section>

  <section *ngIf="isAnySpendLimitSet()">
    <div *ngIf="spendProfile?.enableStartTime" class="spend-control-tooltip-divider"></div>
    <div class="uppercase white-60 w-100 mb-4" i18n>Spend Limits</div>
    <div *ngIf="spendProfile?.dailySpendLimit" class="d-flex justify-space-between mb-4">
      <p class="m-0" i18n>Daily limit:</p>
      <p class="m-0">{{spendProfile.dailySpendLimit | currency}}</p>
    </div>
    <div *ngIf="spendProfile?.weeklySpendLimit" class="d-flex justify-space-between mb-4">
      <p class="m-0" i18n>Weekly limit:</p>
      <p class="m-0">{{spendProfile.weeklySpendLimit | currency}}</p>
    </div>
    <div *ngIf="spendProfile?.monthlySpendLimit" class="d-flex justify-space-between mb-4">
      <p class="m-0" i18n>Monthly limit:</p>
      <p class="m-0">{{spendProfile.monthlySpendLimit | currency}}</p>
    </div>
    <div *ngIf="spendProfile?.billingCycleSpendLimit" class="d-flex justify-space-between mb-4">
      <p class="m-0" i18n>Per billing cycle:</p>
      <p class="m-0">{{spendProfile.billingCycleSpendLimit | currency}}</p>
    </div>
    <div *ngIf="spendProfile?.transactionLimit" class="d-flex justify-space-between mb-4">
      <p class="m-0" i18n>Per transaction:</p>
      <p class="m-0">{{spendProfile.transactionLimit | currency}}</p>
    </div>
  </section>

  <section *ngIf="shouldShowCashAdvance">
    <div
      *ngIf="spendProfile?.enableStartTime || isAnySpendLimitSet()"
      class="spend-control-tooltip-divider"
    ></div>
    <div class="uppercase white-60 w-100 mb-2" i18n>Cash Advance</div>
    <div *ngIf="spendProfile?.dailyWithdrawalLimitInCents" class="d-flex justify-space-between mb-4">
      <p class="m-0" i18n>Daily withdrawal limit:</p>
      <p class="m-0">{{spendProfile.dailyWithdrawalLimitInCents | currency}}</p>
    </div>
    <div *ngIf="spendProfile?.weeklyWithdrawalLimitInCents" class="d-flex justify-space-between mb-4">
      <p class="m-0" i18n>Weekly withdrawal limit:</p>
      <p class="m-0">{{spendProfile.weeklyWithdrawalLimitInCents | currency}}</p>
    </div>
  </section>

  <section class="phx-web-type-body-small">
    <div
      *ngIf="spendProfile?.enableStartTime || isAnySpendLimitSet() || shouldShowCashAdvance"
      class="spend-control-tooltip-divider"
    ></div>
    <div class="uppercase white-60 w-100 mb-2" i18n>Category limits</div>
    <ul *ngIf="!this.areAllSpendCategoriesAllowed; else allCategoriesAuthorized" class="unstyled-list mb-0">
      <li *ngFor="let spendCategoryTooltipData of spendCategoriesTooltipData" class="category-limit">
        <ng-container
          *ngIf="spendCategoryTooltipData.subCategories.length > 0 || allowedSpendCategoriesNamesWithNoSetLimits[spendCategoryTooltipData.categoryId]"
        >
          <div>{{spendCategoryTooltipData.categoryName}}</div>
          <ul class="subcategories-list-container phx-web-type-body-small list-style-disc">
            <li *ngFor="let subCategory of spendCategoryTooltipData.subCategories" class="subcategories-list">
              <div class="phx-web-color-content-on-summary-standard normalcase">{{subCategory.categoryName}}</div>
              <ul
                *ngIf="spendProfile.categorySpecificSpendLimits[subCategory.id]" 
                class="subcategory-limits-list unstyled-list mb-0"
              >
                <ng-container *ngFor="let subCategoryLimit of SPEND_SUBCATEGORY_LIMITS_MAP">
                  <!-- first index is key, second index is value -->
                  <li
                    *ngIf="spendProfile.categorySpecificSpendLimits[subCategory.id][subCategoryLimit[0]]"
                    class="d-flex justify-space-between"
                  >
                    <span class="phx-web-color-content-on-summary-subdued normalcase">{{subCategoryLimit[1]}}</span>
                    <span class="phx-web-color-content-on-summary-emphasis">
                      {{spendProfile.categorySpecificSpendLimits[subCategory.id][subCategoryLimit[0]] | currency}}
                    </span>
                  </li>
                </ng-container>
              </ul>
            </li>
            <li
              *ngIf="allowedSpendCategoriesNamesWithNoSetLimits[spendCategoryTooltipData.categoryId]"
              class="subcategories-list subcategories-without-limits phx-web-color-content-on-summary-standard normalcase mt-4"
              [attr.data-spendCategoryId]="spendCategoryTooltipData.categoryId"
            >
              <span i18n>Allowed</span>:
              {{ allowedSpendCategoriesNamesWithNoSetLimits[spendCategoryTooltipData.categoryId].join(', ').toLowerCase() | sentenceCase }}
            </li>
          </ul>
        </ng-container>
      </li>
    </ul>
  </section>

  <section
    *ngIf="this.isTooltipMaxHeightReached && removedSubCategoryLimitsCount > 0"
    class="mt-4"
    i18n
  >{{removedSubCategoryLimitsCount}} more</section>
</div>

<ng-template #allSpendCategoriesAllowed>
  <div class="spend-control-tooltip-title" i18n>Spend categories allowed</div>
  <span i18n>All categories allowed</span>
</ng-template>

<ng-template #allCategoriesAuthorized>
  <span i18n>All categories allowed</span>
</ng-template>